var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    rx: 10,
    fill: "#0492C2",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_68_80)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M32.5625 39.6875C30.5957 39.6875 29 38.0339 29 35.9929C29 33.9519 30.5957 32.2983 32.5625 32.2983C33.0109 32.2984 33.4551 32.3856 33.8702 32.5551C34.0963 31.455 34.6297 30.4415 35.4085 29.6324C36.1874 28.8232 37.1797 28.2516 38.2704 27.9838C39.3611 27.716 40.5054 27.763 41.5704 28.1194C42.6355 28.4758 43.5776 29.1269 44.2874 29.9972C44.9973 30.8676 45.4457 31.9214 45.5807 33.0363C45.7157 34.1512 45.5317 35.2816 45.0501 36.2962C44.5685 37.3108 43.809 38.1679 42.8598 38.7682C41.9106 39.3685 40.8106 39.6873 39.6875 39.6875H32.5625Z",
    fill: "#0492C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5625 39.6875C30.5957 39.6875 29 38.0339 29 35.9929C29 33.9519 30.5957 32.2983 32.5625 32.2983C33.0109 32.2984 33.4551 32.3856 33.8702 32.5551C34.0963 31.455 34.6297 30.4415 35.4085 29.6324C36.1874 28.8232 37.1797 28.2516 38.2704 27.9838C39.3611 27.716 40.5054 27.763 41.5704 28.1194C42.6355 28.4758 43.5776 29.1269 44.2874 29.9972C44.9973 30.8676 45.4457 31.9214 45.5807 33.0363C45.7157 34.1512 45.5317 35.2816 45.0501 36.2962C44.5685 37.3108 43.809 38.1679 42.8598 38.7682C41.9106 39.3685 40.8106 39.6873 39.6875 39.6875H32.5625Z",
    stroke: "#0492C2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.375 36.125V33.75C12.3747 30.9484 13.2003 28.2089 14.7485 25.874C16.2967 23.539 18.4988 21.7122 21.0796 20.622C23.6603 19.5318 26.5052 19.2264 29.2585 19.7442C32.0119 20.262 34.5515 21.5798 36.5599 23.5331",
    stroke: "#0492C2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.125 36.125V33.75C17.1248 31.9939 17.6113 30.2722 18.5306 28.776C19.4498 27.2798 20.7657 26.0676 22.3323 25.2742C23.8988 24.4807 25.6546 24.1369 27.4047 24.281C29.1548 24.4251 30.8307 25.0515 32.2463 26.0906",
    stroke: "#0492C2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.875 36.125V33.75C21.875 33.0325 22.0374 32.3244 22.3503 31.6787C22.6631 31.033 23.1181 30.4666 23.6812 30.0219C24.2442 29.5773 24.9007 29.2659 25.6013 29.1113C26.302 28.9567 27.0285 28.9628 27.7264 29.1292",
    stroke: "#0492C2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_68_80"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.fc2ae7c0a0363dfb234f19b7bf9f4924.svg";
export { ForwardRef as ReactComponent };